import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { setting } from '../../../../../setting';
import { RestService } from 'app/shared/rest.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'usb-select-items',
  templateUrl: './select-items.component.html',
  styleUrls: ['./select-items.component.scss']
})
export class SelectItemsComponent implements OnInit {

  @Input() items:any;
  @Input() currencyItinerary: string;
  @Input() currencyAgency: any;
  @Input() currencies: any[] = [];
  @Input() getClientsSettingAppBooking: any;
  @Output() nextStep = new EventEmitter<any>();
  @Output() selectItem = new EventEmitter<any>();
  @Output() paymentCreditCardPending = new EventEmitter<any>();
  @Output() errorQueryCreditCardPending = new EventEmitter<any>();
  paymentCreditCards: any;

  rate

  selectAllMode = false;
  constructor(private _restService: RestService) {

  }

  ngOnInit() {

  }

  deSelectAll(){
    this.selectAllMode = !this.selectAllMode;
    for (let index = 0; index < this.items.length; index++) {
      if(this.items[index].selected == true){
        this.items[index].selected = false;
        this.selectItem.emit(this.items[index]);
      }
    }
  }

  selectAll(){
    this.selectAllMode = !this.selectAllMode;
    for (let index = 0; index < this.items.length; index++) {
      if(this.items[index].selected == false){
        this.items[index].selected = true;
        this.selectItem.emit(this.items[index]);
      }
    }
  }

  addItem(item, i){
    this.selectItem.emit(item);
  }

  stingUpperCase(str){
    if(!str) {
      return 'Nombre no definido';
    }
    let e = str.toLowerCase()
    return e.replace(/\b\w/g, l => l.toUpperCase())
  }

  getPrice(item): number {

    let price: number = 0;

      if((item?.addonsIncluded && item?.addonsIncluded.length > 0) ||
         (item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0)) {

       let additionalPaymentOffice: number = 0;
       let addonsIncludedPaymentOffice: any[] = [];

       if(item?.addonsIncluded && item?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.addonsIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       } else if(item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.amenitiesIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       }
      additionalPaymentOffice = addonsIncludedPaymentOffice.reduce((total, addon) => {

        let priceProf: number = 0;

        switch(item.category_id) {
          case 1: // Hotel
            priceProf =  total + ((addon.price || 0) * (addon.qtyOptional || 1));
            break;
          case 2: // Rent a car
            priceProf =  total + ((addon.totalNetPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 6: // Tour
            priceProf =  total + ((addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 8: // Traslado
            priceProf =  total + (addon?.totalPrice || 0);
            break;
          case 9: // Ticket
            priceProf =  total + ((addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
        }

        return total + (priceProf || 0);
      }, 0);

      if(additionalPaymentOffice > 0) {
        price = item.netPriceBooking - additionalPaymentOffice;
      }
      if(additionalPaymentOffice === 0) {
        price = item.netPriceBooking;
      }
    } else {
      price = item.netPriceBooking;
    }

    return price;
  }

  getPaymentOffice(item): boolean {

    let addonsIncludedPaymentOffice: boolean = false;

      if(item?.addonsIncluded && item?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.addonsIncluded.some(c => c.PaymentOffice === true || c.paymentOffice === true);
       } else if(item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.amenitiesIncluded.some(c => c.PaymentOffice === true || c.paymentOffice === true);
       }

    return addonsIncludedPaymentOffice;
  }

  getSumPaymentOffice(item): number {

    let additionalPaymentOffice: number = 0;
    let addonsIncludedPaymentOffice: any[] = [];

      if(item?.addonsIncluded && item?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.addonsIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       } else if(item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.amenitiesIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       }
      additionalPaymentOffice = addonsIncludedPaymentOffice.reduce((total, addon) => {

        let priceProf: number = 0;

        switch(item.category_id) {
          case 1: // Hotel
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 2: // Rent a car
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 6: // Tour
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 8: // Traslado
            priceProf =  total + (addon?.totalPrice || 0);
            break;
          case 9: // Ticket
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
        }

        return total + (priceProf || 0);
      }, 0);

    return additionalPaymentOffice;
  }

}
